import { createTheme } from '@mui/material/styles';

const FlagstoneTheme = createTheme({
  typography: {
    fontFamily: "\"Helvetica\", \"Arial\", sans-serif"
  },
  palette: {
    secondary: {
      main: '#fafafa',
      secondary: '#4654FB'
    },
    primary: {
      main: '#4654FB',
      secondary: '#fafafa',
      fontColor: '#616A6E',

    },

    text: {
      primary: '#0C0E29',
      secondary: 'rgba(12, 14, 41, 0.8)',
      tertiary: 'rgba(12, 14, 41, 0.6)',
      light: '#F8F8F8',
    },

    lightGreen: {
      main: '#5CC958',
      secondary: '#fafafa'
    },
    grey: {
      main: "#EFEFEF"
    },
    green: {
      main: "#5CC958"
    },
    orange: {
      main: "#F59127",
      secondary: "rgb(245, 145, 40,0.28)"
    },
    red: {
      main: "#D84949",
      secondary: "rgb(216, 73, 73,0.28)"
    }
  },
  boxShadow : {
    success: 'rgb(92, 201, 88) 0px 0px 7px',
    error: 'rgb(216, 73, 73) 0px 0px 7px',
    warning: 'rgb(216, 137, 73) 0px 0px 7px'
  }
});

export default FlagstoneTheme;